<template>
  <validation-observer ref="selectRules">
    <b-row class="px-2 pt-2">
      <b-col sm="12" md="12" lg="3">
        <b-form-group label="DR" label-for="departamento-input" label-class="font_size_label">
          <v-select
            id="select-departamento"
            variant="custom"
            label="descricao"
            placeholder="Selecione um departamento"
            :clearable="false"
            v-model="localSearch.departamento"
            :options="departamentoSelect"
            :loading="loading.departamento"
          >
            <span slot="no-options">Nenhuma opção selecionável.</span>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="12" lg="3">
        <b-form-group label="Campanha *" label-for="campanha-input" label-class="font_size_label">
          <validation-provider #default="{ errors }" name="campanha" rules="required">
            <v-select
              id="select-campanha"
              variant="custom"
              label="descricao"
              placeholder="Selecione uma campanha"
              :clearable="false"
              v-model="localSearch.campanha"
              :options="campanhaSelect"
              :loading="loading.campanha"
              :disabled="!localSearch.departamento"
            >
              <span slot="no-options">Nenhuma opção selecionável.</span>
            </v-select>
            <small v-if="errors[0]" class="text-danger">Este campo é de preenchimento obrigatório.</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="12" lg="3">
        <b-form-group label="Unidade Operacional" label-for="unidade-input" label-class="font_size_label">
          <v-select
            id="select-unidade"
            variant="custom"
            label="descricao"
            placeholder="Selecione uma unidade operacional"
            :clearable="false"
            v-model="localSearch.unidade"
            :options="unidadeSelect"
            :loading="loading.unidade"
            :disabled="!localSearch.campanha || !localSearch.departamento"
          >
            <span slot="no-options">Nenhuma opção selecionável.</span>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="12" lg="3">
        <b-form-group label="Empresa" label-for="empresa-input" label-class="font_size_label">
          <v-select
            id="select-empresa"
            variant="custom"
            label="nome_empresa"
            :placeholder="filtersEnabled ? 'Selecione uma empresa' : 'Selecione uma DR e campanha primeiro'"
            :clearable="false"
            v-model="localSearch.empresa"
            :options="empresaSelect"
            :loading="loading.empresa"
            :disabled="!filtersEnabled"
          >
            <template #option="item">
              <template v-if="item.documento">
                <strong>{{ item.documento | formataCpfCnpj }}</strong><br>
                <span>{{ item.nome_empresa }}</span>
              </template>
              <span v-else>{{ item.nome_empresa }}</span>
            </template>
            <template #selected-option="item">
              <span v-if="item.documento">{{ item.documento | formataCpfCnpj }}</span>
              <span v-else>{{ item.nome_empresa }}</span>
            </template>
            <span slot="no-options">Nenhuma opção selecionável.</span>
          </v-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="px-2 pt-lg-1">
      <b-col sm="12" md="12" lg="3">
        <b-form-group label="Colaborador" label-for="colaborador-input" label-class="font_size_label">
          <b-form-input
            id="colaborador-input"
            v-model="localSearch.colaborador"
            :placeholder="filtersEnabled ? 'Colaborador' : 'Selecione uma DR e campanha primeiro'"
            :disabled="!filtersEnabled"
          />
        </b-form-group>
      </b-col>
      <b-col sm="12" md="12" lg="3">
        <b-form-group label="Vacina" label-for="vacina-input" label-class="font_size_label">
          <v-select
            id="select-vacina"
            variant="custom"
            label="descricao"
            :placeholder="filtersEnabled ? 'Selecione uma vacina' : 'Selecione uma DR e campanha primeiro'"
            :clearable="false"
            v-model="localSearch.vacina"
            :options="vacinaSelect"
            :loading="loading.vacina"
            :disabled="!filtersEnabled"
          >
            <span slot="no-options">Nenhuma opção selecionável.</span>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="12" lg="3">
        <b-form-group label="Dose" label-for="dose-input" label-class="font_size_label">
          <v-select
            id="select-dose"
            variant="custom"
            label="label"
            placeholder="Selecione uma dose"
            :clearable="true"
            v-model="localSearch.dose"
            :options="dosesSelect"
            :disabled="!filtersEnabled"
          >
            <span slot="no-options">Nenhuma opção selecionável.</span>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="12" lg="3">
        <b-form-group label="Tipo de Ação" label-for="tipo-acao-input" label-class="font_size_label">
          <v-select
            id="select-tipo-acao"
            variant="custom"
            label="label"
            :placeholder="filtersEnabled ? 'Selecione o tipo de ação' : 'Selecione uma DR e campanha primeiro'"
            :clearable="false"
            v-model="localSearch.tipo_acao"
            :options="tipoAcaoSelect"
            :disabled="!filtersEnabled"
          >
            <span slot="no-options">Nenhuma opção selecionável.</span>
          </v-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="px-2 pt-lg-1">
      <b-col sm="12" md="12" lg="3">
        <b-form-group label="Situação do Envio" label-for="situacao-input" label-class="font_size_label">
          <v-select
            id="select-situacao"
            variant="custom"
            label="label"
            :placeholder="filtersEnabled ? 'Selecione uma situação' : 'Selecione uma DR e campanha primeiro'"
            :clearable="false"
            v-model="localSearch.situacao"
            :options="situacaoSelect"
            :disabled="!filtersEnabled"
          >
            <span slot="no-options">Nenhuma opção selecionável.</span>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="12" lg="3">
        <b-form-group label="Inconsistências" label-for="inconsistencias-input" label-class="font_size_label">
          <v-select
            id="select-inconsistencias"
            variant="custom"
            label="label"
            :placeholder="filtersEnabled ? 'Selecione inconsistências' : 'Selecione uma DR e campanha primeiro'"
            :clearable="false"
            v-model="localSearch.inconsistencias"
            :options="inconsistenciasSelect"
            :disabled="!filtersEnabled"
          >
            <span slot="no-options">Nenhuma opção selecionável.</span>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="12" lg="3">
        <b-form-group label="Data Início" label-for="inicio-input" label-class="font_size_label">
          <b-form-datepicker
            id="inicio-input"
            v-model="localSearch.inicio"
            placeholder="DD/MM/AAAA"
            locale="pt-BR"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
            :disabled="!filtersEnabled"
            :hide-header="true"
            button-variant="custom-blue"
            :max="today"
          />
        </b-form-group>
      </b-col>
      <b-col sm="12" md="12" lg="3">
        <b-form-group label="Data Final" label-for="final-input" label-class="font_size_label">
          <b-form-datepicker
            id="final-input"
            v-model="localSearch.final"
            placeholder="DD/MM/AAAA"
            locale="pt-BR"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
            :disabled="!filtersEnabled"
            :hide-header="true"
            button-variant="custom-blue"
            :min="localSearch.inicio"
            :max="today"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="px-2 py-3">
      <b-col lg="6" md="6" sm="6">
        <div class="d-flex">
          <b-button @click="$emit('search')" variant="primary-button" class="mr-2" :disabled="!filtersEnabled">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Pesquisar</span>
          </b-button>
          <b-button type="reset" class="cor_botao" @click="$emit('clean')" variant="outline-primary">
            <feather-icon icon="XIcon" class="mr-50" />
            <span class="align-middle">Limpar</span>
          </b-button>
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="6">
        <div class="d-flex justify-content-end">
          <div class="d-flex flex-column align-items-end">
            <b-button
              variant="success"
              class="mb-2"
              :disabled="!filtersEnabled"
              @click="$emit('export-csv')"
              v-b-tooltip.hover.bottom="filtersEnabled ? 'Exportação de arquivo CSV' : 'Selecione uma DR e campanha primeiro'"
            >
              <feather-icon icon="DownloadIcon" class="mr-50" />
              <span class="align-middle">Exportar CSV</span>
            </b-button>
            <div class="d-flex align-items-center">
              <span class="mr-1">Mostrar</span>
              <v-select
                id="tableSize"
                v-model="localPageSize"
                @input="$emit('page-size-change', localPageSize)"
                :options="pageSizeOptions"
                :clearable="false"
                style="min-width: 80px;"
              >
                <span slot="no-options">Nenhuma opção selecionável.</span>
              </v-select>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import {BButton, BCol, BFormDatepicker, BFormGroup, BFormInput, BRow} from 'bootstrap-vue';
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import {required} from '@validations'
import vSelect from 'vue-select';

export default {
  name: 'IntegracaoRndsFiltros',
  components: {
    BRow, BCol, BFormGroup, BFormInput, BButton, BFormDatepicker,
    ValidationProvider, ValidationObserver, vSelect
  },
  props: {
    search: { type: Object, required: true },
    loading: { type: Object, required: true },
    departamentoSelect: { type: Array, default: () => [] },
    campanhaSelect: { type: Array, default: () => [] },
    unidadeSelect: { type: Array, default: () => [] },
    empresaSelect: { type: Array, default: () => [] },
    vacinaSelect: { type: Array, default: () => [] },
    dosesSelect: { type: Array, default: () => [] },
    situacaoSelect: { type: Array, default: () => [] },
    inconsistenciasSelect: { type: Array, default: () => [] },
    tipoAcaoSelect: { type: Array, default: () => [] },
    pageSize: { type: Number, default: 10 },
    pageSizeOptions: { type: Array, default: () => [10, 25, 50, 100] }
  },
  data() {
    return {
      localPageSize: this.pageSize,
      required
    };
  },
  computed: {
    localSearch: {
      get() { return this.search; },
      set(val) { this.$emit('update:search', val); }
    },
    filtersEnabled() {
      return this.localSearch.campanha && this.localSearch.departamento;
    },
    today() {
      return new Date().toISOString().split('T')[0];
    }
  },
  watch: {
    pageSize(val) { this.localPageSize = val; },
    'localSearch.inicio'(newVal) {
      if (newVal && this.localSearch.final) {
        const dataInicio = new Date(newVal);
        const dataFinal = new Date(this.localSearch.final);

        if (dataFinal < dataInicio) {
          this.localSearch.final = '';
        }
      }
    }
  },
  methods: {
    async validarFormulario() {
      return await this.$refs.selectRules.validate();
    }
  }
};
</script>
